import { FooterLinkHeader } from '../../ads-footer.types';
import { FunctionalComponent, VNode, h } from '@stencil/core';
import { getHyperLinkObject } from '../../../core/interfaces/Hyperlink';

export const AdsFooterLinkHeader: FunctionalComponent<FooterLinkHeader> = ({ link, text, title, headingLevel }) => {
  const Heading = `h${headingLevel || 2}`;
  const linkObj = getHyperLinkObject(link);

  const anchorAttributes = {
    href: linkObj?.href,
    hrefLang: linkObj?.hreflang || null,
    rel: linkObj?.rel || null,
    target: linkObj?.target || null,
    title: title || null,
    onClick: linkObj?.onClick || null,
    'data-track': 'true',
    'data-track-value': text,
  };

  return (
    <div class="footer-link-header">
      <Heading>
        <a {...anchorAttributes}>{text}</a>
      </Heading>
    </div>
  ) as VNode;
};
